var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "#FEF6E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#F6A704"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8594 5.04492C13.6721 5.0474 11.5751 5.91739 10.0285 7.46403C8.48185 9.01067 7.61186 11.1076 7.60938 13.2949C7.60938 20.3543 15.1094 25.6859 15.4291 25.909C15.5552 25.9973 15.7054 26.0447 15.8594 26.0447C16.0133 26.0447 16.1636 25.9973 16.2897 25.909C16.6094 25.6859 24.1094 20.3543 24.1094 13.2949C24.1069 11.1076 23.2369 9.01067 21.6903 7.46403C20.1436 5.91739 18.0466 5.0474 15.8594 5.04492ZM15.8594 10.2949C16.4527 10.2949 17.0327 10.4709 17.5261 10.8005C18.0194 11.1302 18.404 11.5987 18.631 12.1469C18.8581 12.695 18.9175 13.2983 18.8017 13.8802C18.686 14.4621 18.4003 14.9967 17.9807 15.4162C17.5611 15.8358 17.0266 16.1215 16.4446 16.2373C15.8627 16.353 15.2595 16.2936 14.7113 16.0666C14.1631 15.8395 13.6946 15.455 13.365 14.9616C13.0353 14.4683 12.8594 13.8883 12.8594 13.2949C12.8594 12.4993 13.1754 11.7362 13.7381 11.1736C14.3007 10.611 15.0637 10.2949 15.8594 10.2949Z",
    fill: "#F6A704"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryLocation);
export default __webpack_public_path__ + "static/media/history_location.62b89a67687594e0a5b0e2cf0d4c82c6.svg";
export { ForwardRef as ReactComponent };